<template>
  <div>
    <h6>Supplier Consents</h6>
    <supplier-specific-terms-british-gas
      :v="$v"
      v-if="supplierId == 2"
    ></supplier-specific-terms-british-gas>
    <supplier-specific-terms-eon
      :v="$v.form"
      v-else-if="supplierId == 4"
    ></supplier-specific-terms-eon>
    <supplier-specific-terms-eon-next
      :v="$v.form"
      v-else-if="supplierId == 111"
    ></supplier-specific-terms-eon-next>
    <supplier-specific-terms-edf
      :v="$v.form"
      v-else-if="supplierId == 7"
    ></supplier-specific-terms-edf>
    <supplier-specific-terms-shell-energy
      :v="$v.form"
      v-else-if="supplierId == 8"
    ></supplier-specific-terms-shell-energy>
    <supplier-specific-terms-ovo
      :v="$v.form"
      v-else-if="supplierId == 12"
    ></supplier-specific-terms-ovo>
    <supplier-specific-terms-utilita
      :v="$v.form"
      v-else-if="supplierId == 22"
    ></supplier-specific-terms-utilita>
    <supplier-specific-terms-pfp-energy
      :v="$v.form"
      v-else-if="supplierId == 42"
    ></supplier-specific-terms-pfp-energy>
    <supplier-specific-terms-octopus-energy
      :v="$v.form"
      v-else-if="supplierId == 49"
    ></supplier-specific-terms-octopus-energy>
    <supplier-specific-terms-so-energy
      :v="$v.form"
      v-else-if="supplierId == 43"
    ></supplier-specific-terms-so-energy>
    <supplier-specific-terms-rebel-energy
      :v="$v.form"
      v-else-if="supplierId == 116"
    ></supplier-specific-terms-rebel-energy>

    <supplier-specific-terms-default
      :v="$v.form"
      v-else
    ></supplier-specific-terms-default>

    <div class="sticky-footer">
      <div class="col-xs-5">
        <uiv-btn type="link" block @click="goToQuestion('address')"
          >Back</uiv-btn
        >
      </div>
      <div class="col-xs-7">
        <uiv-btn type="primary" block @click="onNext">Next</uiv-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { requiredIf } from "vuelidate/lib/validators";
import SupplierSpecificTerms from "../../../../base/components/supplier-specific-terms";

export default {
  name: "SupplierTerms",
  mounted() {
    this.form = this.terms;
  },
  computed: {
    ...mapState({
      quote: ({ storage }) => storage.quote,
      supplierId: ({ personal_details_switch_plan }) =>
        personal_details_switch_plan.supplierId,
      switchPlan: ({ personal_details_switch_plan }) =>
        personal_details_switch_plan,
      terms: ({ personal_details_terms }) => personal_details_terms,
      specialNeedsList: ({ lookups }) => lookups.specialNeeds,
    }),
  },
  validations() {
    return {
      form: {
        neitherSmartMeterInstalled: {
          requiredIf: requiredIf(() => {
            const { electricitySmartMeterInstalled, gasSmartMeterInstalled } =
              this.terms;

            if (
              this.quote.switchType == "gasToGas" ||
              this.quote.switchType == "electricityToElectricity"
            ) {
              return false;
            }

            return !electricitySmartMeterInstalled && !gasSmartMeterInstalled;
          }),
        },
        agreeSmartMeterConditions: {
          requiredIf: requiredIf(() => {
            const { electricitySmartMeterInstalled, gasSmartMeterInstalled } =
              this.terms;

            return electricitySmartMeterInstalled || gasSmartMeterInstalled;
          }),
        },
        specialNeedsId: {
          requiredIf: requiredIf(
            () => this.terms.hasMedicalConditionOrIndividualRequirement
          ),
        },
        suppliersTermsAndConditionsAreAccepted: {
          requiredIf: requiredIf(
            (form) => !form.suppliersTermsAndConditionsAreAccepted
          ),
        },
        happyToReceiveCreditCheck: {
          requiredIf: requiredIf((form) => {
            const validateSupplier = [8, 49];

            if (validateSupplier.indexOf(this.switchPlan.supplierId) > -1) {
              return !form.happyToReceiveCreditCheck;
            }

            return false;
          }),
        },
        happyToHaveDebtInformationAccessed: {
          requiredIf: requiredIf((form) => {
            if (this.switchPlan.supplierId == 22) {
              return !form.happyToHaveDebtInformationAccessed;
            }

            return false;
          }),
        },
        prePaymentMeterId: {
          requiredIf: requiredIf((form) => {
            if (this.switchPlan.payMethod == "PrePaymentMeter") {
              return !form.prePaymentMeterId;
            }

            return false;
          }),
        },
        switchAfterCoolingOfPeriod: {
          requiredIf: requiredIf((form) => {
            if (this.switchPlan.supplierId != 42) {
              return this.terms.switchAfterCoolingOfPeriod == null;
            }

            return false;
          }),
        },
      },
    };
  },
  methods: {
    ...mapActions({
      goToQuestion: "personal_details_questions/goToQuestion",
    }),
    onChangeSpecialNeeds() {
      if (this.terms.hasMedicalConditionOrIndividualRequirement) {
        this.$store.dispatch("lookups/getSpecialNeedsList");
      } else {
        this.terms.specialNeedsId = null;
      }
    },
    onNext() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      this.$scrollTo(".fullscreen-card");
      this.goToQuestion("payment");
    },
  },
  components: {
    ...SupplierSpecificTerms,
  },
};
</script>

<style lang="scss"></style>
